// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import ahoy from "ahoy.js"
import "channels"
import "chartkick/chart.js"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

window.ahoy = ahoy

window.trackSetupEvent = function(name, properties) {
  if (!window.ahoy || typeof window.ahoy.track !== "function") return

  window.ahoy.track(name, properties || {})
}

// Delegated click tracking. Any element (or descendant) carrying
// data-ahoy-click="Event Name" fires that Ahoy event on click; every other
// data-ahoy-* attribute becomes a snake_case property
// (e.g. data-ahoy-api="popup" -> { api: "popup" }). Bound once on document so it
// survives Turbolinks navigations without rebinding.
document.addEventListener("click", function(event) {
  var node = event.target
  if (!node || typeof node.closest !== "function") return

  var el = node.closest("[data-ahoy-click]")
  if (!el) return

  var properties = {}
  Array.prototype.forEach.call(el.attributes, function(attr) {
    var match = attr.name.match(/^data-ahoy-(.+)$/)
    if (!match || match[1] === "click") return

    properties[match[1].replace(/-/g, "_")] = attr.value
  })

  window.trackSetupEvent(el.getAttribute("data-ahoy-click"), properties)
})
